// extracted by mini-css-extract-plugin
export default {"component":"DialogMessage_component__Kywk3"};